
import { Button } from "@/components/ui/button";
import { FaInstagram, FaFacebook, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

const socialLinks = [
  {
    name: "Instagram",
    icon: FaInstagram,
    url: "https://www.instagram.com/brenda.nutricionista/",
    color: "hover:bg-gradient-to-br hover:from-purple-500 hover:via-pink-500 hover:to-orange-400",
  },
  {
    name: "Facebook",
    icon: FaFacebook,
    url: "#",
    color: "hover:bg-[#1877F2]",
  },
  {
    name: "YouTube",
    icon: FaYoutube,
    url: "#",
    color: "hover:bg-[#FF0000]",
  },
  {
    name: "LinkedIn",
    icon: FaLinkedinIn,
    url: "#",
    color: "hover:bg-[#0A66C2]",
  },
  {
    name: "X",
    icon: FaXTwitter,
    url: "#",
    color: "hover:bg-[#000000]",
  },
];

export function SocialLinks() {
  return (
    <div className="flex flex-wrap gap-3">
      {socialLinks.map((social) => (
        <a
          key={social.name}
          href={social.url}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={social.name}
          className={`w-10 h-10 rounded-xl bg-white/10 border border-white/20 text-white flex items-center justify-center transition-all duration-300 hover:scale-110 hover:border-transparent ${social.color}`}
        >
          <social.icon size={18} />
        </a>
      ))}
    </div>
  );
}
